<script setup>
const cdnArchivos = process.env.VUE_APP_CDN_ARCHIVOS

defineProps({
  enlace_logo: {
    type: String,
  },
  titulo: {
    default: 'Soy un tìtulo',
    type: String,
  },
  parrafo: {
    type: String,
  },
  nombre_descarga: {
    type: String,
  },
  enlace_descarga: {
    type: String,
  },
})
</script>
<template>
  <div class="tarjeta">
    <div class="tarjeta-cuerpo">
      <div>
        <img
          :src="enlace_logo"
          alt="logo conahcyt"
          class="m-y-0 invertir"
        />
      </div>

      <div>
        <p class="tarjeta-titulo">
          {{ titulo }}
        </p>
      </div>
      <div v-html="parrafo.replace('<p>', `<p class='m-b-0'>`)"></div>
    </div>
    <div
      class="tarjeta-pie flex flex-contenido-separado m-0 contenedor-enlaces"
    >
      <div>
        <a
          v-if="!nombre_descarga.includes('11.1')"
          :href="cdnArchivos + '/' + enlace_descarga"
          class="boton-primario boton-chico m-t-minimo"
        >
          {{ nombre_descarga }}
        </a>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.tarjeta {
  .contenido-html {
    flex-direction: column;
    .contenedor-enlaces {
      width: 100%;
    }
  }
}
</style>
